import './i18n';
import {useEffect} from "react";
import {Route, Routes} from "react-router-dom";
import Main from "./page/Main";
import Impressum from "./page/Impressum";
import Datenschutz from "./page/Datenschutz";

function IrlRedirect() {
    useEffect(() => {
        window.location.replace("https://www.wingsforlifeworldrun.com/de/teams/XgMlJE");
    }, []);
    return null;
}

function App() {
    return (
        <Routes>
            <Route index element={<Main/>}/>
            <Route path={"/impressum"} element={<Impressum/>}/>
            <Route path={"/datenschutz"} element={<Datenschutz/>}/>
            <Route path="/irl" element={<IrlRedirect/>}/>
        </Routes>
    )
}

export default App;
